import React from "react";
import { Invitations } from "../../organisms";

export default ({ match: { params: { id } } }) => {
  return (
    <Invitations invitationId={id} />
  );
};
